export default {
  path: '/nozzle_manufacturers',
  name: 'nozzle_manufacturers',
  component: () => import('../components/nozzlemanufacturer/Layout'),
  redirect: { name: 'NozzleManufacturerList' },
  meta: {
    breadcrumb: 'profile.nozzle.manufacturers',
  },
  children: [
    {
      name: 'NozzleManufacturerList',
      path: '',
      component: () => import('../views/nozzlemanufacturer/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'NozzleManufacturerCreate',
      path: 'new',
      component: () => import('../views/nozzlemanufacturer/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'NozzleManufacturerUpdate',
      path: ':id/edit',
      component: () => import('../views/nozzlemanufacturer/Update'),
      meta: {
        breadcrumb: 'profile.nozzle.manufacturer',
      },
    },
    {
      name: 'NozzleManufacturerShow',
      path: ':id',
      component: () => import('../views/nozzlemanufacturer/Show'),
      meta: {
        breadcrumb: 'profile.nozzle.manufacturer',
      },
    }
  ]
};
